import { render, staticRenderFns } from "./RectificationList.vue?vue&type=template&id=346841cd&scoped=true"
import script from "./RectificationList.vue?vue&type=script&lang=js"
export * from "./RectificationList.vue?vue&type=script&lang=js"
import style0 from "./RectificationList.vue?vue&type=style&index=0&id=346841cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346841cd",
  null
  
)

export default component.exports